import { clsx, type ClassValue } from "clsx";

/** Tiny wrapper around clsx to keep a single class-merging entry point. */
export function cn(...inputs: ClassValue[]): string {
  return clsx(inputs);
}
